import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Layout from '../../components/layout/Layout'
import Descripcion from '../../components/perfil/Descripcion'
import ImgPerfil from '../../components/perfil/ImgPerfil'
import ItemData from '../../components/perfil/ItemData'
import { startUpdateFrase } from '../../helpers/frase'
import { setAsignaturas, setDisplayName, setFacultad, setGender, setPrograma } from '../../helpers/perfil'
import { refreshFrase } from '../../reducer/FraseDelDiaReducer'
import { setPerfilAsignaturas, setPerfilDisplayName, setPerfilFacultad, setPerfilGender, setPerfilPrograma } from '../../reducer/PerfilReducer'

const PerfilView = () => {
    const [loading, setLoading] = useState()
    const dispatch = useDispatch();
    const {photoURL, description, uid, email, displayName, subjects,faculty,program, gender} = useSelector(state => state.perfil)
    const {sentence} = useSelector(state => state.frase)
    const handleSaveDisplayName = (name) => {
        setLoading(true)
        setDisplayName(name, email)
        .then(() => {
            dispatch(setPerfilDisplayName(name))
            setLoading(false)
        })
        .catch((e) => {
            console.log(e);
            setLoading(false)
        })
    }

    const handleSaveGenero = (newGenero) => {
        setLoading(true)
        setGender(parseInt(newGenero),email)
        .then(() => {
            dispatch(setPerfilGender(parseInt(newGenero)))
            setLoading(false)
        })
        .catch(e => {
            console.log(e)
            setLoading(false)
        })
    }

    const handleSaveFacultad = (newFacultad) => {
        setLoading(true)
        setFacultad(newFacultad,email)
        .then(() => {     
            dispatch(setPerfilFacultad(newFacultad));
            setLoading(false)
        })
        .catch(e => {
            console.log(e);
            setLoading(false)
        })
    }

    const handleAsignaturas = (asig) => {
        setLoading(true)
        setAsignaturas(asig, email)
        .then(() => {
            dispatch(setPerfilAsignaturas(asig))
            setLoading(false)
        })
        .catch((e) => {
            console.log(e);
            setLoading(false)
        })
    }

    const handleSaveProgram = (newProgram) => {
        setLoading(true)
        setPrograma(newProgram,email)
        .then( async () => {     
            await dispatch(setPerfilPrograma(newProgram));
            setLoading(false)
        })
        .catch(e => {
            console.log(e);
            setLoading(false)
        })  
    }

    const handleUpdateFrase = (newfrase) => {
        setLoading(true)
        startUpdateFrase(email, uid, newfrase)
        .then( async () => {

            await dispatch(refreshFrase(newfrase, email))
            setLoading(false)
        })
        .catch(e => {
            console.log(e)
            setLoading(false)
        })
    }


    return (
        <Layout>
            <div className='container_perfil'>
                <div className='cont_perfil'>
                    <div className='cont_img_perfil'>
                        <ImgPerfil photoURL={photoURL} email={email} />
                    </div>
                    <div className='cont_descripcion_perfil'>
                        <Descripcion description={description} email={email} />
                    </div>
                </div>
                <div className='cont_data'>
                    <ItemData 
                        label='Nombre: ' 
                        text={displayName} type='1' 
                        message={false}
                        funcion={handleSaveDisplayName}
                        pLoad={loading}
                    />
                    <ItemData label='Correo: ' text={email} type='0' message={false} /> 
                    <ItemData 
                        label='Asignaturas: ' 
                        text={subjects} type='1' 
                        message={true}
                        funcion={handleAsignaturas}
                        pLoad={loading}
                    /> 
                    <ItemData 
                        label='Reflexión: ' 
                        text={sentence} type='1' 
                        message={false}
                        funcion={handleUpdateFrase}
                        pLoad={loading}
                    /> 
                    <ItemData 
                        label='Facultad: '
                        text={faculty} type='2' 
                        message={false}
                        funcion={handleSaveFacultad}
                        pLoad={loading}
                    /> 
                    <ItemData 
                        label='Programa: ' 
                        text={program} type='1' 
                        message={false}
                        funcion={handleSaveProgram}
                        pLoad={loading}
                    /> 
                    <ItemData 
                        label='Genero: ' 
                        text={gender === 1 ? 'Masculino' : 'Femenino'} 
                        type='2' message={false}
                        funcion={handleSaveGenero}
                        pLoad={loading}
                    />
                </div>
            </div>
        </Layout>
    )
}

export default PerfilView
